import { render, staticRenderFns } from "./TwoIndependentGroups.vue?vue&type=template&id=06569acf&"
import script from "./TwoIndependentGroups.vue?vue&type=script&lang=js&"
export * from "./TwoIndependentGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports